export const ROUTES = {
  SETUP_DEVICE: "/setup-device",
  OPTIMIZE_SIGNAL: "/optimize-signal",
  RECORDING: "/recording",
  FINISH: "/finish",
};
